import App from './App';
export default App;



// WEBPACK FOOTER //
// ../shop_main/index.js